import axios from 'axios'

export default {
    uploadCsv(file, campaignType, pcp) {
        return axios.post(`/admin/claim-profile`, {
            file: file.base64File,
            campaignType,
            pcp,
        })
    },

    inviteToPractice(data) {
        return axios.post(`/users/${data.userId}/join-invites/practice`, data)
    },

    inviteToNetwork(data) {
        return axios.post(`/users/${data.userId}/join-invites/network`, data)
    },
}
